/**
 * Country dropdown.
 *
 * @type {Object}
 *
 * @package Zola-Electric
 */

const country = {

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		this.initCountryDropdown();
		this.countryDropdown();
		this.currentMenu();
	},

	/**
	 * Initiate Country Dropdown
	 *
	 * @return {void}
	 */
	initCountryDropdown: function() {
		let menuItem = '';

		const countryMenuList = $( '#country-menu li' );

		if ( ! countryMenuList.length ) {
			return;
		}

		const dropdownButton = $( '#country-dropdwon' );

		if ( countryMenuList.hasClass( 'current-country' ) ) {

			menuItem = $( '#country-menu li.current-country a' ).children( 'img, span' ).clone();

		} else {

			menuItem = $( '#country-menu li:first-child a' ).children().clone();

		}

		if ( $( '.hq.menu-item' ).hasClass( 'current-country' ) ) {
			dropdownButton.addClass( 'hq' );
		}

		dropdownButton.append( menuItem );
	},

	/**
	 * Country dropdown.
	 *
	 * @return {void}
	 */
	countryDropdown: function() {
		const dropdown  = $( '#country-dropdwon' );
		const container = $( '.country-dropdown-wrapper' );

		if ( ! dropdown.length ) {
			return;
		}

		dropdown.on( 'click', ( event ) => {
			$( event.currentTarget ).toggleClass( 'active' );

			$( window ).on( 'keydown.dropdown', keyDown );

			setTimeout( () => {

				$( document ).on( 'click.dropdown', documentClick );

			}, 1 );

		} );

		// Hide dropdown on esc key press.
		const keyDown = function ( event ) {

			if ( dropdown.hasClass( 'active' ) ) {

				if ( 27 === event.keyCode ) {
					dropdown.removeClass( 'active' );
				}

			}

			$( window ).off( 'keydown.dropdown' );

		};

		const documentClick = function ( event ) {

			if ( dropdown.hasClass( 'active' ) && ( ! container.is( event.target ) && 0 === container.has( event.target ).length ) ) {

				dropdown.removeClass( 'active' );

				$( document ).off( 'click.dropdown' );

			}

		};
	},

	/**
	 * Set current country.
	 *
	 * @return {void}
	 */
	currentMenu: function() {
		const currMenuWrap = $( '#country-dropdwon' );
		const menuWrap     = $( '#country-menu a' );

		if ( ! menuWrap.length ) {
			return;
		}

		menuWrap.on( 'click', ( event ) => {

			let menu = $( event.currentTarget ).children().clone();
			currMenuWrap.children().remove();
			currMenuWrap.append( menu );

		} );
	}
};

export { country };
